import { maxLength, minLength, noWhiteStartOrEnd, required } from '@ps/web-shared-validators';
import React from 'react';

import TextInput from '../../../../../../components/TextInput/TextInput';

import {
  TXTWCL_House_Number_cannot_be_longer__ELL,
  TXTWCL_House_number_5,
  TXTWCL_House_number_must_be_providedX,
  TXTWCL_Street_Name_cannot_be_longer_t_ELL,
  TXTWCL_Street_Name_cannot_be_shorter__ELL,
  TXTWCL_Street_name_3,
  TXTWCL_Street_name_must_be_providedX,
  TXTWCL_Your_house_number_should_only__ELL
} from './StreetAddressExtendedDE.messages.json';

interface Props {
  disabled?: boolean;
}

const MIN_LENGTH = 4;
const MAX_LENGTH = 150;

const StreetAddressExtendedDE: React.FC<Props> = ({ disabled }) => (
  <>
    <TextInput
      id="streetName"
      label={TXTWCL_Street_name_3}
      disabled={disabled}
      validators={[
        required([TXTWCL_Street_name_must_be_providedX, TXTWCL_Your_house_number_should_only__ELL]),
        minLength(4, { ...TXTWCL_Street_Name_cannot_be_shorter__ELL, values: { 0: MIN_LENGTH } }),
        noWhiteStartOrEnd,
        maxLength(150, { ...TXTWCL_Street_Name_cannot_be_longer_t_ELL, values: { 0: MAX_LENGTH } })
      ]}
    />
    <TextInput
      id="buildingNumber"
      label={TXTWCL_House_number_5}
      disabled={disabled}
      validators={[
        required(TXTWCL_House_number_must_be_providedX),
        noWhiteStartOrEnd,
        maxLength(20, { ...TXTWCL_House_Number_cannot_be_longer__ELL, values: { 0: 20 } })
      ]}
    />
  </>
);

export default StreetAddressExtendedDE;
